import { APP_CONSTANTS } from 'src/app/constants/constants';

import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-rm-client-details',
    templateUrl: './rm-client-details.component.html',
    styleUrls: ['./rm-client-details.component.scss']
})
export class RmClientDetailsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() page_data: any;
	@Input() page_operation_type: any;

	@Output() clientOperationsClosed = new EventEmitter<any>();
	@Output() clientOperationsUpdated = new EventEmitter<any>();

	current_date: any = new Date();
	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		this.getGenders();
		this.getStatus();
		this.getStates();
		this.getRegion();
		this.getProductGroups();
		setTimeout(() => {
			this.openClientOperationModal();
		}, 200);
	}

	region_list: any = [];
	getRegion() {
		const financial_institution = this.user_details.financial_institution;

		this.commonService.getData('/region?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.region_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_group_list: any = [];
	getProductGroups() {
		this.commonService.getData('/product?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.product_group_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatus() {
		this.commonService.getData('/clientStatus?no_page=true/').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	states_list: any = [];
	getStates() {
		this.commonService.getData('/state?no_page=true/').subscribe(
			(res: any) => {
				this.states_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('pageOperationsModal') pageOperationsModal: TemplateRef<any>;
  	private pageOperationsModalRef: MatDialogRef<TemplateRef<any>>;
	openClientOperationModal() {
		if (this.page_operation_type == 'Add') {
			this.page_data = JSON.parse(JSON.stringify(this.ideal_page_data));
			this.page_data.status = 'Active';

		} else {
			this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'MM-dd-yyyy');
			this.page_data.member_since = this.datePipe.transform(this.page_data.member_since, 'MM-dd-yyyy');

			if ( this.page_data.last_date_of_contact != "" &&  this.page_data.last_date_of_contact != null) {
				this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'MM-dd-yyyy');
			}

			if ( this.page_data.last_periodic_review_date != "" &&  this.page_data.last_periodic_review_date != null) {
				this.page_data.last_periodic_review_date = this.datePipe.transform(this.page_data.last_periodic_review_date, 'MM-dd-yyyy');
			}
		}

		this.pageOperationsModalRef = this.dialog.open(this.pageOperationsModal, { disableClose: true } );
		this.pageOperationsModalRef.afterClosed().subscribe((result) => {
			this.closeClientOperationModal();
		});
	}

	closeClientOperationModal() {
		this.clientOperationsClosed.emit("Closed");
		this.pageOperationsModalRef.close();
	}

	client_operation_stepper: any = 1;
	navigateBack() {
		this.client_operation_stepper = this.client_operation_stepper - 1;
	}

	product_error: boolean = false;
	validateClientDetails() {
		if (this.client_operation_stepper == 1) {
			const fields = [
				{ key: "client_id", type: "text" },
				{ key: "member_since", type: "date" },
				{ key: "first_name", type: "text" },
				{ key: "last_name", type: "text" },
				{ key: "email", type: "email" },
				{ key: "birth_date", type: "date" },
				{ key: "individual_income_in_dollars_actual", type: "number" },
				{ key: "status_id", type: "text" },
				{ key: "address_line_1", type: "text" },
				{ key: "city", type: "text" },
				{ key: "state_id", type: "text" },
				{ key: "region_id", type: "text" },
				{ key: "zip_code", type: "text" },
			];

			if (this.validateClientIndividualSection(fields)) {
				this.client_operation_stepper = this.client_operation_stepper + 1;
			}

		} else if (this.client_operation_stepper == 2) {
			const fields = [
				{ key: "household_id", type: "text" },
				{ key: "is_primary_contact", type: "boolean" },
			];

			if (this.validateClientIndividualSection(fields)) {
				if (this.page_data.is_primary_contact == true) {
					if ((this.page_data.adults_in_household != "" && this.page_data.adults_in_household != null) || (this.page_data.adults_in_household == "0")) {
						this.page_data_errors.adults_in_household = false;
					} else {
						this.page_data_errors.adults_in_household = true;
					}

					if ((this.page_data.children_in_household != "" && this.page_data.children_in_household != null) || (this.page_data.children_in_household == "0")) {
						this.page_data_errors.children_in_household = false;
					} else {
						this.page_data_errors.children_in_household = true;
					}

					if ((this.page_data.household_income_in_dollars_actual != "" && this.page_data.household_income_in_dollars_actual != null) || this.page_data.household_income_in_dollars_actual == "0") {
						this.page_data_errors.household_income_in_dollars_actual = false;
					} else {
						this.page_data_errors.household_income_in_dollars_actual = true;
					}

					if (
						this.page_data_errors.adults_in_household == false &&
						this.page_data_errors.children_in_household == false &&
						this.page_data_errors.household_income_in_dollars_actual == false
					) {
						this.page_data_errors.adults_in_household = false;
						this.page_data_errors.children_in_household = false;
						this.page_data_errors.household_income_in_dollars_actual = false;
						this.client_operation_stepper = this.client_operation_stepper + 1;
					}
				} else {
					this.client_operation_stepper = this.client_operation_stepper + 1;
				}
			}
		} else if (this.client_operation_stepper == 3) {
			const fields = [
				// { key: "client_wallet_share_from_lpl_actual", type: "number" },
				// { key: "client_net_worth_from_lpl_actual", type: "number" },
				{ key: "net_worth_actual", type: "number" },
				{ key: "source", type: "text" },
				{ key: "last_date_of_contact", type: "text"}
			];

			if (this.validateClientIndividualSection(fields)) {
				this.client_operation_stepper = this.client_operation_stepper + 1;
			}
		} else if (this.client_operation_stepper == 4) {
			if (this.client_goal_operation_type == "") {
				this.client_operation_stepper = this.client_operation_stepper + 1;
			}
		} else if (this.client_operation_stepper == 5) {
			if (this.page_data.products.length > 0) {
				this.product_error = false;
				if (this.client_product_operation_type == "") {
					this.saveClientInformation();
				}
			} else {
				this.product_error = true;
			}
		}
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	validEmail(email) {
		if (
			email != '' &&
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		) {
			return true;
		} else {
			return false;
		}
	}

	global_error: boolean = false;
	validateClientIndividualSection(fields) {
		if (fields.length > 0) {
			// let error: boolean = false;
			this.global_error = false;
			for (let index = 0; index < fields.length; index++) {
				if (fields[index].type == "text" || fields[index].type == "number" || fields[index].type == "date") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "email") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null && this.validEmail(this.page_data[fields[index]["key"]])) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "boolean") {
					if (this.page_data[fields[index]["key"]] == true || this.page_data[fields[index]["key"]] == false) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				}
			}

			// if (error == true) {
			// 	return false;
			// } else {
			// 	return true;
			// }

			if (this.global_error == true) {
				return false;
			} else {
				return true;
			}

		} else {
			this.global_error = false
			return true;
		}
	}

	saveClientInformation() {
		this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'yyyy-MM-dd');
		this.page_data.member_since = this.datePipe.transform(this.page_data.member_since, 'yyyy-MM-dd');
		this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'yyyy-MM-dd');
		this.page_data.last_periodic_review_date = this.datePipe.transform(this.page_data.last_periodic_review_date, 'yyyy-MM-dd');

		if (this.page_data.net_worth_actual) {
			this.page_data.net_worth = this.page_data.net_worth_actual;
		}

		// if (this.page_data.client_wallet_share_from_lpl_actual) {
		// 	this.page_data.client_wallet_share_from_lpl = this.page_data.client_wallet_share_from_lpl_actual;
		// }

		// if (this.page_data.client_net_worth_from_lpl_actual) {
		// 	this.page_data.client_net_worth_from_lpl = this.page_data.client_net_worth_from_lpl_actual;
		// }

		if (this.page_data.household_income_in_dollars_actual) {
			this.page_data.household_income_in_dollars = this.page_data.household_income_in_dollars_actual;
		}

		if (this.page_data.market_value_of_home_in_dollars_actual) {
			this.page_data.market_value_of_home_in_dollars = this.page_data.market_value_of_home_in_dollars_actual;
		}

		if (this.page_data.home_equity_available_for_mortgage_in_dollars_actual) {
			this.page_data.home_equity_available_for_mortgage_in_dollars = this.page_data.home_equity_available_for_mortgage_in_dollars_actual;
		}

		if (this.page_data.individual_income_in_dollars_actual) {
			this.page_data.individual_income_in_dollars = this.page_data.individual_income_in_dollars_actual;
		}

		if (this.page_data.total_networth_actual) {
			this.page_data.total_networth = this.page_data.total_networth_actual;
		}

		if (this.page_data.money_managed_revenue_actual) {
			this.page_data.money_managed_revenue = this.page_data.money_managed_revenue_actual;
		}

		if (this.page_data.current_assests_actual) {
			this.page_data.current_assests = this.page_data.current_assests_actual;
		}

		if (this.page_data.expenses_actual) {
			this.page_data.expenses = this.page_data.expenses_actual;
		}

		if (this.page_data.liabilities_actual) {
			this.page_data.liabilities = this.page_data.liabilities_actual;
		}

		if (this.page_data.other_investment_actual) {
			this.page_data.other_investment = this.page_data.other_investment_actual;
		}

		if (this.page_operation_type == 'Add') {
			this.update_client_summary_data_loader = true;
			this.commonService.postData('/client/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Client has been added successfully.');
					this.clientOperationsUpdated.emit("Added");

					this.pageOperationsModalRef.close();

					this.update_client_summary_data_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
			// this.commonService.updateData('/client/' + this.page_data.id + '/', this.page_data).subscribe(
			// 	(res: any) => {
			// 		this.commonService.showToast('success', 'Client has been updated successfully.');
			// 		this.clientOperationsUpdated.emit("Updated");

			// 		this.pageOperationsModalRef.close();
			// 	},
			// 	(err) => {
			// 		this.commonService.showToast('error', err.error);
			// 	},
			// );


			this.update_client_summary_data_loader = true;

			const payload = {
				id: this.page_data.id,
    			date_of_birth: this.page_data.birth_date
			};

			this.commonService.postData('/getbirthdatepopup/', payload).subscribe(
				(res: any) => {
					if (res["show_pop_up"] == true) {
						this.update_client_summary_data = res;
						this.openUpdateClientDetailsModal();
						this.update_client_summary_data_loader = false;
					} else {
						this.update_client_summary_data_loader = false;

						this.updateClientDetails("");
					}
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);


		}
	}

	update_client_summary_data: any;
	update_client_summary_data_loader: boolean = false;
	@ViewChild('updateClientDetailsModal') updateClientDetailsModal: TemplateRef<any>;
	private updateClientDetailsModalRef: MatDialogRef<TemplateRef<any>>;
	openUpdateClientDetailsModal() {
		this.updateClientDetailsModalRef = this.dialog.open(this.updateClientDetailsModal, { disableClose: true });
		this.updateClientDetailsModalRef.afterClosed().subscribe((result) => {
			this.closeUpdateClientDetailsModal();
		});
	}

	closeUpdateClientDetailsModal() {
		this.update_client_summary_data = {};
		this.update_client_summary_data_loader = false;
		this.updateClientDetailsModalRef.close();
	}

	update_client_loader: boolean = false;
	updateClientDetails(type) {
		this.update_client_loader = true;

		let payload: any = JSON.parse(JSON.stringify(this.page_data));
		if (type != "") {
			payload.advisor_choice = type;
		}

		this.commonService.updateData('/client/' + payload.id + '/', payload).subscribe(
			(res: any) => {
				if (type != "") {
					this.closeUpdateClientDetailsModal();
				}

				this.commonService.showToast('success', 'Client has been updated successfully.');
				this.clientOperationsUpdated.emit("Updated");

				this.pageOperationsModalRef.close();

				this.update_client_loader = false;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	ideal_page_data: any = {
		client_id: "",
		member_since: "",
		first_name: "",
		last_name: "",
		telephone_number: "",
		email: "",
		gender_id: "",
		birth_date: "",
		education: "",
		occupation: "",
		years_experience: "",
		marital_status: "",
		individual_income_in_dollars_actual: "",
		status_id: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state_id: "",
		region_id: "",
		zip_code: "",
		homeowner_or_renter: "",
		years_in_residence: "",
		address_2_line_1: "",
		address_2_line_2: "",
		address_2_city: "",
		address_2_state_id: "",
		address_2_region_id: "",
		address_2_zip_code: "",
		address_2_years_in_residence: "",
		address_2_homeowner_or_renter: "",
		address_3_line_1: "",
		address_3_line_2: "",
		address_3_city: "",
		address_3_state_id: "",
		address_3_region_id: "",
		address_3_zip_code: "",
		address_3_years_in_residence: "",
		address_3_homeowner_or_renter: "",
		household_id: "",
		is_primary_contact: false,
		adults_in_household: "",
		children_in_household: "",
		household_income_in_dollars_actual: "",
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: "",
		economic_stability: "",
		vehicle_type: "",
		vehicle_count: "",
		property_type: "",
		home_equity_available_for_mortgage_in_dollars_actual: "",
		loan_to_value_in_percentage: "",
		market_value_of_home_in_dollars_actual: "",
		// client_wallet_share_from_lpl_actual: "",
		// client_net_worth_from_lpl_actual: "",
		net_worth_actual: "",
		total_networth_actual: "",
		source: "",
		lead_assigned_date: "",
		segment: "",
		last_date_of_contact: "",
		money_managed_revenue_actual: "",
		last_periodic_review_date: "",
		confidence_flag: "",
		linkedin_url: "",
		twitter_url: "",
		facebook_url: "",
		client_goals: [],
		current_assests_actual: "",
		liabilities_actual: "",
		expenses_actual: "",
		other_investment_actual: "",
		products: []
	};

	page_data_errors: any = {
		client_id: false,
		member_since: false,
		first_name: false,
		last_name: false,
		telephone_number: false,
		email: false,
		gender_id: false,
		birth_date: false,
		education: false,
		occupation: false,
		years_experience: false,
		marital_status: false,
		individual_income_in_dollars_actual: false,
		status_id: false,
		address_line_1: false,
		address_line_2: false,
		city: false,
		state_id: false,
		region_id: false,
		zip_code: false,
		homeowner_or_renter: false,
		years_in_residence: false,
		address_2_line_1: false,
		address_2_line_2: false,
		address_2_city: false,
		address_2_state_id: false,
		address_2_region_id: false,
		address_2_zip_code: false,
		address_2_years_in_residence: false,
		address_2_homeowner_or_renter: false,
		address_3_line_1: false,
		address_3_line_2: false,
		address_3_city: false,
		address_3_state_id: false,
		address_3_region_id: false,
		address_3_zip_code: false,
		address_3_years_in_residence: false,
		address_3_homeowner_or_renter: false,
		household_id: false,
		is_primary_contact: false,
		adults_in_household: false,
		children_in_household: false,
		household_income_in_dollars_actual: false,
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: false,
		economic_stability: false,
		vehicle_type: false,
		vehicle_count: false,
		property_type: false,
		home_equity_available_for_mortgage_in_dollars_actual: false,
		loan_to_value_in_percentage: false,
		market_value_of_home_in_dollars_actual: false,
		// client_wallet_share_from_lpl_actual: false,
		// client_net_worth_from_lpl_actual: false,
		net_worth_actual: false,
		total_networth_actual: false,
		source: false,
		lead_assigned_date: false,
		segment: false,
		last_date_of_contact: false,
		money_managed_revenue_actual: false,
		last_periodic_review_date: false,
		confidence_flag: false,
		linkedin_url: false,
		twitter_url: false,
		facebook_url: false,
		client_goals: false,
		current_assests_actual: false,
		liabilities_actual: false,
		expenses_actual: false,
		other_investment_actual: false,
		products: false
	};

	client_goal_details: any = {
		investment_purpose: "",
		target_amount: "",
		accomplished_target: "",
		investment_goal_tenure: "",
		risk_tolerance: "",
	};
	client_goal_operation_type: any = "";
	client_goal_operation_index: any = null;
	client_goal_details_errors: any = {
		investment_purpose: false,
		target_amount: false,
		accomplished_target: false,
		investment_goal_tenure: false,
		risk_tolerance: false,
	};

	clientGoalOperations(data, type, index) {
		this.client_goal_details = JSON.parse(JSON.stringify(data));
		this.client_goal_operation_type = type;
		this.client_goal_operation_index = index;
	}

	validateClientGoal() {
		if (
			this.client_goal_details.investment_purpose != "" && this.client_goal_details.investment_purpose != null
		) {
			this.client_goal_details_errors.investment_purpose = false;
		} else {
			this.client_goal_details_errors.investment_purpose = true;
		}

		if (
			this.client_goal_details.target_amount != "" && this.client_goal_details.target_amount != null
		) {
			this.client_goal_details_errors.target_amount = false;
		} else {
			this.client_goal_details_errors.target_amount = true;
		}

		if (
			this.client_goal_details.accomplished_target != "" && this.client_goal_details.accomplished_target != null
		) {
			this.client_goal_details_errors.accomplished_target = false;
		} else {
			this.client_goal_details_errors.accomplished_target = true;
		}

		if (
			this.client_goal_details.investment_goal_tenure != "" && this.client_goal_details.investment_goal_tenure != null
		) {
			this.client_goal_details_errors.investment_goal_tenure = false;
		} else {
			this.client_goal_details_errors.investment_goal_tenure = true;
		}

		if (
			this.client_goal_details.risk_tolerance != "" && this.client_goal_details.risk_tolerance != null
		) {
			this.client_goal_details_errors.risk_tolerance = false;
		} else {
			this.client_goal_details_errors.risk_tolerance = true;
		}

		if (
			this.client_goal_details_errors.investment_purpose == false &&
			this.client_goal_details_errors.target_amount == false &&
			this.client_goal_details_errors.accomplished_target == false &&
			this.client_goal_details_errors.investment_goal_tenure == false &&
			this.client_goal_details_errors.risk_tolerance == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveClientGoal() {
		if (this.validateClientGoal()) {
			if (this.client_goal_operation_type == "Add") {
				this.page_data.client_goals.push(this.client_goal_details);
				this.cancelClientGoal();
			} else {
				if (this.client_goal_details.id) {
					const index = this.page_data.client_goals.findIndex((x) => x.id == this.client_goal_details.id);
					this.page_data.client_goals.splice(index, 1, this.client_goal_details);
					this.cancelClientGoal();
				} else {
					this.page_data.client_goals.splice(this.client_goal_operation_index, 1, this.client_goal_details);
					this.cancelClientGoal();
				}
			}

		}

	}

	cancelClientGoal() {
		this.client_goal_details = {
			investment_purpose: "",
			target_amount: "",
			accomplished_target: "",
			investment_goal_tenure: "",
			risk_tolerance: "",
		};
		this.client_goal_operation_type = "";
		this.client_goal_operation_index = null;
		this.client_goal_details_errors = {
			investment_purpose: false,
			target_amount: false,
			accomplished_target: false,
			investment_goal_tenure: false,
			risk_tolerance: false,
		};
	}

	@ViewChild('deleteClientGoalModal') deleteClientGoalModal: TemplateRef<any>;
	private deleteClientGoalModalRef: MatDialogRef<TemplateRef<any>>;
	deleteClientGoal(data, index) {
		this.client_goal_details = JSON.parse(JSON.stringify(data));
		this.client_goal_operation_index = JSON.parse(JSON.stringify(index));
		this.deleteClientGoalModalRef = this.dialog.open(this.deleteClientGoalModal, { disableClose: true });
		this.deleteClientGoalModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteClientGoal();
		});
	}

	closeDeleteClientGoal() {
		this.cancelClientGoal();
		this.deleteClientGoalModalRef.close();
	}

	deleteClientGoalDetails() {
		if (this.client_goal_details.id) {
			const index = this.page_data.client_goals.findIndex((x) => x.id == this.client_goal_details.id);
			this.page_data.client_goals.splice(index, 1);
			this.closeDeleteClientGoal();
		} else {
			this.page_data.client_goals.splice(this.client_goal_operation_index, 1);
			this.closeDeleteClientGoal();
		}
	}

	client_product_details: any = {
		product: "",
		policy_number: "",
		tenure: "",
		aum: "",
		type: "",
		start_date: "",
    interest_rate: "",
    monthly_fees:"",
	};
	client_product_operation_type: any = "";
	client_product_operation_index: any = null;
	client_product_details_errors: any = {
		product: false,
		policy_number: false,
		tenure: false,
		aum: false,
		type: false,
		start_date: false,
    interest_rate: false,
    monthly_fees:false,
	};

	clientProductOperations(data, type, index) {
		this.client_product_details = JSON.parse(JSON.stringify(data));
		this.client_product_operation_type = type;
		this.client_product_operation_index = index;

		if (this.client_product_details.start_date == "" || this.client_product_details.start_date == null) {
			this.client_product_details.start_date = new Date();
		} else {
			this.client_product_details.start_date = this.datePipe.transform(this.client_product_details.start_date, 'MM-dd-yyyy');
		}

	}

	validateClientProduct() {
		if (
			this.client_product_details.product != "" && this.client_product_details.product != null
		) {
			this.client_product_details_errors.product = false;
		} else {
			this.client_product_details_errors.product = true;
		}

		if (
			this.client_product_details.policy_number != "" && this.client_product_details.policy_number != null
		) {
			this.client_product_details_errors.policy_number = false;
		} else {
			this.client_product_details_errors.policy_number = true;
		}

		if (
			this.client_product_details.type != "" && this.client_product_details.type != null
		) {
			this.client_product_details_errors.type = false;
		} else {
			this.client_product_details_errors.type = true;
		}

		if (
			this.client_product_details.aum != "" && this.client_product_details.aum != null
		) {
			this.client_product_details_errors.aum = false;
		} else {
			this.client_product_details_errors.aum = true;
		}

		if (
			this.client_product_details.start_date != "" && this.client_product_details.start_date != null
		) {
			this.client_product_details_errors.start_date = false;
		} else {
			this.client_product_details_errors.start_date = true;
		}


    if (
			this.client_product_details.interest_rate != "" && this.client_product_details.interest_rate != null
		) {
			this.client_product_details_errors.interest_rate = false;
		} else {
			this.client_product_details_errors.interest_rate = true;
		}

    if (
			this.client_product_details.monthly_fees != "" && this.client_product_details.monthly_fees != null
		) {
			this.client_product_details_errors.monthly_fees = false;
		} else {
			this.client_product_details_errors.monthly_fees = true;
		}




		if (
			(this.client_product_details.product_type == 'Life Time' || (this.client_product_details.tenure != '' && this.client_product_details.tenure != null))
		) {
			this.client_product_details_errors.tenure = false;
		} else {
			this.client_product_details_errors.tenure = true;
		}

		if (
			this.client_product_details_errors.product == false &&
			this.client_product_details_errors.policy_number == false &&
			this.client_product_details_errors.type == false &&
			this.client_product_details_errors.aum == false &&
			this.client_product_details_errors.start_date == false &&
      this.client_product_details_errors.interest_rate == false &&
      this.client_product_details_errors.monthly_fees == false &&
			this.client_product_details_errors.tenure == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveClientProduct() {
		if (this.validateClientProduct()) {
			this.client_product_details.amount = APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + this.client_product_details.aum;
			this.client_product_details.start_date = this.datePipe.transform(this.client_product_details.start_date, 'yyyy-MM-dd');
			if (this.client_product_operation_type == "Add") {
				const productIndex = this.product_group_list.findIndex((x) => x.id == this.client_product_details.product);

				this.client_product_details.product_name = this.product_group_list[productIndex]['name'];

				this.page_data.products.push(this.client_product_details);

				this.cancelClientProduct();
			} else {
				if (this.client_product_details.id) {
					const index = this.page_data.products.findIndex((x) => x.id == this.client_product_details.id);
					const productIndex = this.product_group_list.findIndex((x) => x.id == this.client_product_details.product);
					this.client_product_details.product_name = this.product_group_list[productIndex].name;
					this.page_data.products.splice(index, 1, this.client_product_details);
					this.cancelClientProduct();
				} else {
					const productIndex = this.product_group_list.findIndex((x) => x.id == this.client_product_details.product);
					this.client_product_details.product_name = this.product_group_list[productIndex].name;
					this.page_data.products.splice(this.client_product_operation_index, 1, this.client_product_details);
					this.cancelClientProduct();
				}
			}

			if (this.page_data.products.length > 0) {
				this.product_error = false;
			}

		}

	}

	cancelClientProduct() {
		this.client_product_details = {
			product: "",
			policy_number: "",
			tenure: "",
			aum: "",
			type: "",
			start_date: "",
      interest_rate : "",
      monthly_fees: "",
		};
		this.client_product_operation_type = "";
		this.client_product_operation_index = null;
		this.client_product_details_errors = {
			product: false,
			policy_number: false,
			tenure: false,
			aum: false,
			type: false,
			start_date: false,
      interest_rate : false,
      monthly_fees: false,
		};
	}

	getProductType(id) {
		const index = this.product_group_list.findIndex((x) => x.id == id);
		if (index > -1) {
			if (this.product_group_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	  }

	@ViewChild('deleteClientProductModal') deleteClientProductModal: TemplateRef<any>;
	private deleteClientProductModalRef: MatDialogRef<TemplateRef<any>>;
	deleteClientProduct(data, index) {
		this.client_product_details = JSON.parse(JSON.stringify(data));
		this.client_product_operation_index = JSON.parse(JSON.stringify(index));
		this.deleteClientProductModalRef = this.dialog.open(this.deleteClientProductModal, { disableClose: true });
		this.deleteClientProductModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteClientProduct();
		});
	}

	closeDeleteClientProduct() {
		this.cancelClientProduct();
		this.deleteClientProductModalRef.close();
	}

	deleteClientProductDetails() {
		if (this.client_product_details.id) {
			const index = this.page_data.products.findIndex((x) => x.id == this.client_product_details.id);
			this.page_data.products.splice(index, 1);
			this.closeDeleteClientProduct();
		} else {
			this.page_data.products.splice(this.client_product_operation_index, 1);
			this.closeDeleteClientProduct();
		}
	}

	@ViewChild('householdLookupModal') householdLookupModal: TemplateRef<any>;
	private householdLookupModalRef: MatDialogRef<TemplateRef<any>>;
	openHouseholdLookupModal() {
		this.householdLookupModalRef = this.dialog.open(this.householdLookupModal, { disableClose: true });
		this.householdLookupModalRef.afterClosed().subscribe((result) => {
			this.closeHouseholdLookupModal();
		});
	}

	closeHouseholdLookupModal() {
		this.householdLookupModalRef.close();
		this.household_list = [];
		this.household_search_key = "";
	}

	changePrimaryContact() {
		if (this.page_data.is_primary_contact == true) {
			this.generateHouseholdID();
		}
	}



	generated_household_id: any = "";
	generateHouseholdID() {
		// if (this.page_data.household_id == "" || this.page_data.household_id == null) {
		// 	if (this.generated_household_id == "" || this.generated_household_id != null) {
		// 		this.commonService.getData('/generatehouseholdid/').subscribe(
		// 			(res: any) => {
		// 				this.generated_household_id = res;
		// 				this.page_data.household_id = this.generated_household_id;
		// 			},
		// 			(err) => {
		// 				this.commonService.showToast('error', err.error);
		// 			},
		// 		);
		// 	}
		// }

		if (this.page_data.household_id == "" || this.page_data.household_id == null) {
			this.commonService.getData('/generatehouseholdid/').subscribe(
				(res: any) => {
					this.generated_household_id = res;
					this.page_data.household_id = this.generated_household_id;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	household_search_key: any = "";
	lookUpHouseHold() {
		this.household_search_key = "";
		this.openHouseholdLookupModal();
	}

	household_list: any = [];
	searchHousehold() {
		this.commonService.getData('/gethouseholdid/?search=' + this.household_search_key).subscribe(
			(res: any) => {
				this.household_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	copy(data) {
		this.page_data.household_id = data.household_id;
		this.page_data.household_primary_contact_name = data.household_primary_contact_name;
		this.closeHouseholdLookupModal();
	}

	@ViewChild('dobChangeModal') dobChangeModal: TemplateRef<any>;
	private dobChangeModalRef: MatDialogRef<TemplateRef<any>>;
	openDOBChangeModal() {
		if (this.page_operation_type != "Add") {
			this.dobChangeModalRef = this.dialog.open(this.dobChangeModal, { disableClose: true });
			this.dobChangeModalRef.afterClosed().subscribe((result) => {
				this.closeDOBChangeModal();
			});
		}
	}

	closeDOBChangeModal() {
		this.dobChangeModalRef.close();
	}

}
